// @ts-nocheck
import * as React from "react";

const DefaultFile: React.FC = () => {
    return (
        <svg viewBox="0 0 50 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.63333 26.1228V54.1917H48.1385V11.9509H36.3959V1.84766H8.65313V8.15725H6.81152V0H38.9899C42.6533 3.38084 46.3365 6.74201 49.9999 10.1032V56H34.9305H21.8809C16.8512 56 11.8413 56 6.81152 56V26.0835H8.65313L8.63333 26.1228Z"
                fill="currentColor"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 9.57251H32.4556V24.747H0V9.57251Z" fill="currentColor" />
        </svg>
    );
};

export default React.memo(DefaultFile);
